"use client";

import { useViewer } from "@/hooks/use-viewer";

export function useViewerQueryState() {
  const viewer = useViewer();
  const session = viewer.isAuthenticated ? { user: viewer.user } : null;

  return {
    viewer,
    session,
    viewerId: viewer.userId,
    isSessionPending: false,
    isSessionResolved: true,
    isAuthenticated: viewer.isAuthenticated,
    enabledWhenSessionResolved: true,
    enabledWhenAuthenticated: viewer.isAuthenticated,
  };
}
